import { useState, useRef } from "react";

const useKeepOpenedOnAction = ({ timeout }) => {
  const [shouldKeepOpened, setKeepOpened] = useState(false);
  const timeoutRef = useRef(null);

  return {
    shouldKeepOpened,
    onAction: () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setKeepOpened(true);
    },
    onDone: () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        timeoutRef.current = null;
        setKeepOpened(false);
      }, timeout);
    },
  };
};

export default useKeepOpenedOnAction;
